import React, { useEffect, useState } from "react";
import Playlist from "../playlist.json";

const Mp3Player = () => {
  const [title, setTitle] = useState("Mp3Player");
  const [artist, setArtist] = useState("");
  const [url, setUrl] = useState();
  const [time, setTime] = useState(0);
  const [bar, setBar] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const [change, setChange] = useState(0);

  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setChange(change + 1);
    }, 7);
    if (change === 100) {
      return () => {
        clearInterval(intervalTwo);
      };
    }
  }, []);

  const handleChangeState = (title, artist, url, time) => {
    setBar(0);
    setTitle(title);
    setArtist(artist);
    console.log(`".${url}"`);
    setUrl(url);
    setTime(parseInt(time));
    setIsPlaying(true);
    setDisableButton(false);
    window.clearInterval(intervalId);
  };

  const stopPlay = () => {
    setTitle("Mp3Player");
    setArtist("");
    setUrl(null);
    setTime(0);
    setIsPlaying(false);
    setBar(0);
    setDisableButton(true);
    window.clearInterval(intervalId);
  };

  useEffect(() => {
    if (isPlaying) {
      let interval = setInterval(() => {
        setBar((prevBar) => prevBar + Math.ceil(100 / time));
      }, 1000);

      setIntervalId(interval);

      if (bar === 100) {
        setTitle("Mp3Player");
        setArtist("");
        setUrl(null);
        setTime(0);
        setIsPlaying(false);
        setBar(0);
        setDisableButton(true);
        window.clearInterval(intervalId);
      }
    }
    return () => {
      window.clearInterval(intervalId);
    };
  }, [isPlaying, bar, time, url]);

  return (
    <>
      <div className="player" style={{ opacity: Math.ceil(change / 100) }}>
        <div className="player_container">
          {isPlaying ? (
            <button
              disabled={disableButton}
              onClick={() => {
                setIsPlaying(false);
              }}
              className="play icone_pause"
            ></button>
          ) : (
            <button
              disabled={disableButton}
              onClick={() => {
                setIsPlaying(true);
              }}
              className="play icone_play"
            ></button>
          )}

          <div className="progress_mp3">
            <div className="inner_mp3" style={{ width: `${bar}%` }}></div>
          </div>
          <div onClick={stopPlay} className="play grey icone_sound"></div>
        </div>
        <div className="player_container_2">
          <div></div>
          <div className="marquee">
            <span className="marquee_headline">
              {title} {artist}
            </span>
          </div>
        </div>
        <div className="player_container_3">
          <div></div>

          <ul className="play_list">
            {Playlist.map((el, i) => (
              <li
                onClick={(e) =>
                  handleChangeState(
                    e.target.getAttribute("title"),
                    e.target.getAttribute("artist"),
                    e.target.getAttribute("url"),
                    e.target.getAttribute("time")
                  )
                }
                key={el.id}
              >
                <span
                  title={el.title}
                  artist={el.artist}
                  url={el.url}
                  time={el.time}
                >
                  {el.id} {el.title}
                </span>
                <p>{el.artist}</p>
              </li>
            ))}
          </ul>
          <audio autoPlay>
            <source src={`".${url}"`} type="audio/mpeg" />
          </audio>
        </div>
      </div>
    </>
  );
};

export default Mp3Player;
